module.exports = __webpack_public_path__ + "img/calender.dbd02c04.svg";